module.exports = __webpack_public_path__ + "img/content-2.c2c93985.svg";